import { StandardDto } from "../cic/cic-question.dto";
import { FileDto } from "../files/files.dto";
import { RiskDocumentDto } from "../risk-documents/risk-documents.dto";
import { SectorDto } from "../sectors/sectors.dto";

export interface RiskDocumentAnswerDto {
  id: number;
  applicationId: number;
  riskTemplateDocumentId: number;
  riskTemplateDocument: RiskDocumentDto;
  applicationRiskDocumentAnswers: ApplicationRiskDocumentAnswerDto[];
  riskLevel?: RiskLevelEnum;
}

export interface ApplicationRiskDocumentAnswerDto {
  applicationRiskDocumentId: number;
  fileId: string;
  file: FileDto;
}

export interface CreateRiskDocumentAnswerDto {
  applicationRiskDocumentId: number;
  fileIds: string[];
  riskLevel?: RiskLevelEnum;
}

export interface UpdateRiskDocumentAnswerDto {
  id: number;
  riskLevel?: RiskLevelEnum;
}

export interface UpsertRiskDocumentAnswerDto {
  id?: number;
  standardId?: number;
  standard?: StandardDto;
  sectorId?: number;
  sector?: SectorDto;
  attachmentFileId?: string;
  attachmentFile?: FileDto;
}

export enum RiskLevelEnum {
  Low = 1,
  Medium = 2,
  High = 3,
}

export interface RiskDocumentAnswerByApplicationUidDto {
  applicationRiskDocuments: RiskDocumentAnswerDto[];
}
